import {useState,useEffect,useRef} from "react";
import {Link,useNavigate} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../../../core/img";
import {all_routes} from "../../../router/all_routes";
import Table from "../../../../core/dataTable/index";
import Modal_Item_Add from "../../app/item/modalItemAdd";
import Select from "react-select";
import {Toaster} from 'react-hot-toast';
/* -- biz9 import start -- */
import {Str,DateTime,Log} from "biz9-utility";
import FormNoData from '../../../formNoData';
import {Image_Service} from "biz9-image";
import {Data_Logic} from "biz9-data-app";
import {Field,Message,Title,Type,Url,Project_Table} from "../../../../constant";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table} from "biz9-portal-app";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,Template,Toast_Message,Storage,System,User} from "../../../../project";
/* -- biz9 import end -- */
const Dashboard_User_App = () => {
    const navigate = useNavigate();
    const timeoutRef = useRef(null);
    const [val_sub_page_title,setValSubPageTitle] = useState(Title.USER_SIDE_BAR_APPZ);
    const [val_search,setValSearch] = useState("");
    const [stop_search,setStopSearch] = useState('');
    const [apps,setApps] = useState([]);
    const [val_type,setValType] = useState(null);
    const [types,setTypes] = useState([]);
    const [val_category,setValCategory] = useState(null);
    const [categorys,setCategorys] = useState([]);
    const columns = [
    {
title: "APP-ID",
           dataIndex: "app_id",
           key: "app_id",
           render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                    <Link to={all_routes.dashboard_user_app_detail+"?id="+record.id +"&order_number="+record.order_number } className="text-dark">
                   {record.app_id}
                   </Link>
                   </h2>
                   ),
           sorter: true
    },
    {
title: "Title",
       dataIndex: "app_id",
       key: "title",
       render: (text: string, record: any) => (
               <>
               {record.title}
               </>
               ),
       sorter: true
    },
    {
title: "Status",
       dataIndex: "status",
       key: "status",
       render: (text: string, record: any) => (
               <>
               {App.get_app_user_status_type_by_type(record.user_status_type).title}
               </>
               ),
       sorter: true
    },
    {
title: "System Status",
       dataIndex: "status",
       key: "status",
       render: (text: string, record: any) => (
               <>
               {App.get_app_status_type_by_type(record.status_type).label}
               </>
               ),
       sorter: true
    },
 {
title: "Type",
       dataIndex: "type",
       key: "type",
       render: (text: string, record: any) => (
               <>
               {record[Type.APP_TYPE]}
               </>
               ),
       sorter: true
    },
 {
title: "Category",
       dataIndex: "category",
       key: "category",
       render: (text: string, record: any) => (
               <>
               {record[Type.APP_CATEGORY]}
               </>
               ),
       sorter: true
    },
    {
title: "Date & Time",
       dataIndex: "date_create",
       key: "date_create",
       render: (text: string, record: any) => (
               <>
               {DateTime.get_date(record.date_create)}{" "}
               {DateTime.get_time(record.date_create)}
               </>
               ),
       sorter: true
    },
    ];
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_data();
            if(timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            }
            },[]);
    async function get_data () {
        let search = Data_Logic.get_search(Project_Table.APP,{user_id:User.get().id});
        const [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search);
        Log.w('11_data',data);
        bind_items(data);
        Toast_Message.dismiss();
    };
    async function bind_items(data){
        setApps(data.items);
    };
    const post_search = (e) => {
        const value = e.target.value.trim();
        setValSearch(value);
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
                setStopSearch(value);
                let filter = {$or:[
                {title:{ $regex:".*"+String(value),$options:"i"}}
                ]};
                let search = Data_Logic.get_search(Portal_Table.APP,filter);
                post_search_data(search);
                }, 500);
    };
    async function post_search_data(search) {
        Toast_Message.loading(Message.SEARCHING);
        let [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search);
        setApps(data.items);
        Toast_Message.dismiss();
    }
    async function btn_delete(id: any) {
        if(window.confirm(Message.CONFIRM)){
            Toast_Message.loading(Message.DELETING);
            let [response,data] = await Portal_Remote_CMS.search(Portal_Table.APP,[id]);
            Toast_Message.success(response.message);
            setApps(apps.filter(item=>item.id!==id));
        }
    };
    const updateNewItem = (item) => {
        setApps([item, ...apps]);
    };
    const updateValType = (selectedOption) => {
        let search = Data_Logic.get_search(Portal_Table.APP,Data_Logic.get_type_category_search_filter(selectedOption.label,val_category?val_category.label:"Any"));
        post_search_data(search);
        setValType(selectedOption);
    };
    const updateValCategory = (selectedOption) => {
        let search = Data_Logic.get_search(Portal_Table.APP,Data.get_type_category_search_filter(val_type?val_type.label:"Any",selectedOption.label));
        post_search_data(search);
        setValCategory(selectedOption);
    };
    return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="container px-0">
            {/*Inner Content */}
            <div className="content mx-4 mb-4">
            <div className="main-title my-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            <div className="wallet-wrap">
            <div className="wallet-list">
            <div className="wallet-item mt-10">
            <div  className="pt-10">
            <input type='text' autoComplete='off' className='form-control' placeholder={"Search"} value={val_search} onChange={post_search}/>
            </div>
            </div>
            </div>
            <div className="d-flex align-items-center">
            <Link hidden={true} to="#" data-bs-toggle="modal" data-bs-target="#withdraw" className="btn btn-primary">
            {Title.LABEL_ADD}
    </Link>
        </div>
        </div>
        <div className="table-filter pb-4">
        <ul className="filter-item" hidden={true}>
        <li>
        <div className="dropdown">
        <Select  placeholder={'Filter Type'}  classNamePrefix="react-select" className="select" styles={Style.customStyles} options={types} value={val_type} onChange={updateValType} />
        </div>
        </li>
        <li>
        <div className="dropdown">
        <Select  placeholder={'Filter Category'}   classNamePrefix="react-select" className="select" styles={Style.customStyles} options={categorys} value={val_category} onChange={updateValCategory} />
        </div>
        </li>
        </ul>
        </div>
        <div className="table-responsive custom-table">
        <Table onUpdate={setApps} allow_multiple={false} table={Portal_Table.APP} dataSource={apps} columns={columns} Selection={false} />
        </div>
        <div className="table-footer">
        <div id="tablepage" />
        </div>
        </div>
        {/* /Inner Content */}
    </div>
        </div>
        {/* /Page Content */}
    <Modal_Item_Add toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} onUpdate={updateNewItem} table={Portal_Table.PRODUCT}/>
        </>
        );
};
export default Dashboard_User_App;
